import { MARQUEE } from "@/content";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="relative overflow-hidden border-y border-[#0F2B5B]/10 bg-[#FAF9F6] py-8 md:py-10" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max items-center">
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display whitespace-nowrap px-6 text-5xl font-extrabold tracking-tight md:px-10 md:text-8xl ${i % 2 ? "text-outline" : "text-[#0F2B5B]"}`}>
              {t}
            </span>
            <svg viewBox="0 0 24 24" className="h-8 w-8 shrink-0 text-[#FF6B00] md:h-12 md:w-12"><path fill="currentColor" d="M12 0c1 7 5 11 12 12-7 1-11 5-12 12-1-7-5-11-12-12 7-1 11-5 12-12z" /></svg>
          </span>
        ))}
      </div>
    </div>
  );
};
